/**
 * Get if the slider needs navigation or not
 * @param loop [Boolean] If the slider is in loop mode or not
 * @param offset [Number] Init offset of the slider
 * @param bounds [Number] Max offset of the slider
 * @returns [Boolean]
 */
export const needNavigation = (loop, offset, bounds) => {
	return !(!loop && offset <= 0 && offset >= bounds);
};
